import { render, staticRenderFns } from "./ContactingNote.vue?vue&type=template&id=3927da60&scoped=true&"
import script from "./ContactingNote.vue?vue&type=script&lang=js&"
export * from "./ContactingNote.vue?vue&type=script&lang=js&"
import style0 from "./ContactingNote.vue?vue&type=style&index=0&id=3927da60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927da60",
  null
  
)

export default component.exports